export default __webpack_public_path__ + "static/media/QI-CaseStudies.943db07c.jpeg";